import { ProprieteAffichee } from "../proprieteAffichee";
import { Vibration } from "../vibration";
import { VibrationsChartChannel } from "./vibrationsChartChannel";
import { VibrationsChartFFT } from "./vibrationsChartFFT";
import { VibrationsChartHeader } from "./vibrationsChartHeader";


export class VibrationsChart {
  id:string;
  header: VibrationsChartHeader;
  channels: VibrationsChartChannel[];
  ffts: VibrationsChartFFT[];
  fftsHz: number[];
  vecSomme: number;

  idVibrationMaria?: number;
  numeroPtControl?: number;
  picVibration?: number;
  surpression?: number;
  distance?: number;


  constructor(vib: VibrationsChart = undefined) {
   if(vib === undefined){
    this.header = new VibrationsChartHeader();
    this.channels = [];
    this.ffts = [];
    this.fftsHz = [];
   }else{
    this.id = vib.id;
    this.header = vib.header;
    this.channels = vib.channels;
    this.ffts = vib.ffts;
    this.fftsHz = vib.fftsHz;
    this.vecSomme = vib.vecSomme
   }


  }

 initDataVibrationMaria(vib: Vibration){
    this.picVibration = vib.picVibration;
    this.surpression = vib.surpression;
    this.distance = vib.distance;
    this.idVibrationMaria = vib.id;
  }


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('#', 'VIBRATION.#'));
    tab.push(new ProprieteAffichee('fileName', 'VIBRATION.FILE_NAME'));
    tab.push(new ProprieteAffichee('serialNumber', 'VIBRATION.SERIAL_NUMBER'));
    tab.push(new ProprieteAffichee('dateTime', 'VIBRATION.DATE_TIME'));
    tab.push(new ProprieteAffichee('note', 'VIBRATION.NOTE'));
    tab.push(new ProprieteAffichee('time', 'VIBRATION.TIME'));
    tab.push(new ProprieteAffichee('max', 'VIBRATION.MAX'));
    tab.push(new ProprieteAffichee('v-sum', 'VIBRATION.VECTOR_SUM'));
    return tab;
  }


}




